import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import "../../common/Common.css";
import InvoiceTable from "./InvoiceTable";
import api from "../../services/api";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      className="branch_tab"
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
    className: "branch_tab",
  };
}

export default function InvoiceManagement({ userDetail }) {
  const [value, setValue] = React.useState(0);
  const [branch, setBranch] = React.useState([]);
  const [invoiceDetails, setInvoiceDetails] = React.useState([]);

  React.useEffect(() => {
    userDetails();
    getInvoiceDetails();
  }, []);

  const userDetails = async () => {
    let getUserDetails = await api.get(`app/user/current_user`, {});
    setBranch(getUserDetails?.data?.branches);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const getInvoiceDetails = async () => {
    let InvoiceData = await api.get(`app/invoice_management/published/`);
    setInvoiceDetails(InvoiceData?.data);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{ borderBottom: 1, borderColor: "divider", marginBottom: "20px" }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          {branch?.map((b, index) => (
            <Tab
              key={b.id}
              label={b.name}
              {...a11yProps(index)}
              className="branch_name"
            />
          ))}
        </Tabs>
      </Box>
      {branch?.map((b, index) => (
        <CustomTabPanel key={b.id} value={value} index={index}>
          <InvoiceTable
            rows={invoiceDetails.filter((inv) => inv.branch_id === b.id)}
            branchId={b.id}
            invoiceDetails={invoiceDetails}
            getInvoiceDetails={getInvoiceDetails}
            userDetail={userDetail}
          />
        </CustomTabPanel>
      ))}
    </Box>
  );
}
